import { render, staticRenderFns } from "./detailAffiliateUser.vue?vue&type=template&id=5a86ce65&scoped=true"
import script from "./detailAffiliateUser.vue?vue&type=script&lang=js"
export * from "./detailAffiliateUser.vue?vue&type=script&lang=js"
import style0 from "./detailAffiliateUser.vue?vue&type=style&index=0&id=5a86ce65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a86ce65",
  null
  
)

export default component.exports